import React from "react";
import "../../screening-test/index.css";
import arrowImage from "../../../../assets/arrow.png";
import axios from "axios";
import io from "socket.io-client";
import WiscIVCubes from "./wisciv-cubes";
import WiscIVSimilarities from "./wisciv-similarities";
import WiscIVSequencing from "./wisciv-sequencing";
import WiscIVConcepts from "./wisciv-concepts";
import WiscIVCoding from "./wisciv-coding";
import WiscIVVocabulary from "./wisciv-vocabulary";
import WiscIVAlphaNum from "./wisciv-alphanum";
import WiscIVMatrices from "./wisciv-matrices";
import WiscIVComprehension from "./wisciv-comprehension";
import WiscIVSymbols from "./wisciv-symbols";
import WiscIVSubmit from "./wisciv-submit";
import WiscIVArithmetic from "./wisciv-arithmetic";
import WiscIVVerbal from "./wisciv-verbal";
import WiscIVCompletion from "./wisciv-completion";
import WiscIVCancellation from "./wisciv-cancellation";
import WiscIVGeneral from "./wisciv-general";

const faQuestions = require("../../../../utils/asq3TestQuestionsFa.js");
const engQuestions = require("../../../../utils/scoboTestQuestionsEng.js");
const faImages = require("../../../../utils/wisc4TestImages.js");
const faAnswers = require("../../../../utils/scoboTestAnswersFa");
const engAnswers = require("../../../../utils/scoboTestAnswersEng");
const faTestResults = require("../../../../utils/scoboTestResultsFa.js");
const engTestResults = require("../../../../utils/scoboTestResultsEng.js");

const faSubExamNames = ["طراحی با مکعب", "شباهت‌ها"];

class Wisc4 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accessType: "User",
      wisc4Result: null,
      autismBackground: "",
      autismDiagnosis: "",
      childAge: 0,
      execute: false,
      gender: "",
      subexamsCounter: 0,
      questionsCounter: 0,
      imagesToShow: [],
      subexamsToShow: [],
      questionsToShow: [],
      questionsSelectionByAge: [0],
      previousCount: 0,
      questionsTotalNumber: 30,
      questions: [
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
        },
        { 0: 0, 1: 0 },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
          22: 0,
          23: 0,
          24: 0,
          25: 0,
          26: 0,
          27: 0,
          28: 0,
          29: 0,
          30: 0,
          31: 0,
          32: 0,
          33: 0,
          34: 0,
          35: 0,
          36: 0,
          37: 0,
          38: 0,
        },
        {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
          11: 0,
          12: 0,
          13: 0,
          14: 0,
          15: 0,
          16: 0,
          17: 0,
          18: 0,
          19: 0,
          20: 0,
          21: 0,
        },
        { 0: 0, 1: 0 },
        { 0: 0, 1: 0 },
        { 0: 0, 1: 0 },
        { 0: 0, 1: 0 },
        { 0: 0, 1: 0 },
        { 0: 0, 1: 0 },
      ],
      results: {},
      resultsSubscalesText: [
        "مهارت‌های ارتباطی ",
        "مهارت‌های درشت ",
        "مهارت‌های خرد ",
        "مهارت‌های حل مسئله ",
        "مهارت‌های اجتماعی ",
      ],
      screeningAnswer: [],
      screeningbooking: false,
      finishedAnswering: false,
      resultNumber: 0,
      resultSubscales: [0, 0, 0, 0, 0],
      countryCode: "IR", // this.props.languageInput,
      testAnswersOptions: [],
      testResultsText: [],
      isLoaded: false,
      pictureSelector: "",
      socket: null,
      roomId: null,
      userId: null,
    };
  }

  componentDidMount = async () => {
    const response = await axios.post(
      "https://request.kidiar.com/evaluation/request",
      { testName: "WISC4" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 0) {
      window.location.href = "/fa/panel/evaluations/list?test=WISC4"; // It could be changes to show some message to user
    }
    this.setState({ userId: response.data.audienceId });
    this.setState({ roomId: response.data.channelId });
    this.setState({ accessType: response.data.access });
    this.setState({ childAge: response.data.age });
    if (response.data.questions != null && response.data.answers != null) {
      for (let i = 0; i < response.data.questions.length; i++) {
        for (let j = 0; j < response.data.questions[i].length; j++) {
          this.state.questions[i][j] = response.data.answers[i][j];
        }
      }
    }

    console.log("User data is:", response.data);
    console.log("User age is:", response.data.age);
    console.log("Questions are", this.state.questions);

    var socketTemp = io("https://request.kidiar.com");
    socketTemp.emit("send-WISCIV-RNumber", response.data.channelId);
    this.setState({ socket: socketTemp });

    // this.setState({imagesToShow: faImages[receivedAge]})
    this.setState({ imagesToShow: faImages[0] });
    this.setState({ subexamsToShow: faSubExamNames[0] });
    this.setState({ isLoaded: true });
  };

  componentDidUpdate = () => {
    this.state.socket.on(
      "receive-WISCIV-QNumber",
      (receivedENumber, receivedQNumber) => {
        this.setState({ questionsCounter: receivedQNumber });
        this.setState({ subexamsCounter: receivedENumber });
        this.setState({ imagesToShow: faImages[receivedENumber] });
        this.setState({ subexamsToShow: faSubExamNames[receivedENumber] });
      }
    );
  };

  nextQuestionNumberHandler = () => {
    // if (this.state.subexamsCounter == 0 && this.state.questionsCounter == 0 && this.state.childAge >= 96 && this.state.childAge < 204) { // for age 12 to 17
    //   this.setState({questionsCounter: 2})
    //   this.state.socket.emit('send-WISCIV-QNumber', 0, 2)
    // } else if (this.state.subexamsCounter == 0 && this.state.questionsCounter == 1 && this.state.childAge >= 72 && this.state.childAge < 96) { // for age 6 to 8
    //   this.setState({questionsCounter: 3})
    //   this.state.socket.emit('send-WISCIV-QNumber', 0, 3)
    // } else if (this.state.subexamsCounter == 0 && this.state.questionsCounter == 14) {
    if (this.state.subexamsCounter == 0 && this.state.questionsCounter == 14) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 1 });
      this.setState({ imagesToShow: faImages[1] });
      this.setState({ subexamsToShow: faSubExamNames[1] });
      this.state.socket.emit("send-WISCIV-QNumber", 1, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 1 &&
      this.state.questionsCounter == 24
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 2 });
      this.setState({ imagesToShow: faImages[2] });
      this.setState({ subexamsToShow: faSubExamNames[2] });
      this.state.socket.emit("send-WISCIV-QNumber", 2, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 2 &&
      this.state.questionsCounter == 34
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 3 });
      this.setState({ imagesToShow: faImages[3] });
      this.setState({ subexamsToShow: faSubExamNames[3] });
      this.state.socket.emit("send-WISCIV-QNumber", 3, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 3 &&
      this.state.questionsCounter == 30
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 4 });
      this.setState({ imagesToShow: faImages[4] });
      this.setState({ subexamsToShow: faSubExamNames[4] });
      this.state.socket.emit("send-WISCIV-QNumber", 4, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 4 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 5 });
      this.setState({ imagesToShow: faImages[5] });
      this.setState({ subexamsToShow: faSubExamNames[5] });
      this.state.socket.emit("send-WISCIV-QNumber", 5, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 5 &&
      this.state.questionsCounter == 36
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 6 });
      this.setState({ imagesToShow: faImages[6] });
      this.setState({ subexamsToShow: faSubExamNames[6] });
      this.state.socket.emit("send-WISCIV-QNumber", 6, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 6 &&
      this.state.questionsCounter == 32
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 7 });
      this.setState({ imagesToShow: faImages[7] });
      this.setState({ subexamsToShow: faSubExamNames[7] });
      this.state.socket.emit("send-WISCIV-QNumber", 7, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 7 &&
      this.state.questionsCounter == 38
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 8 });
      this.setState({ imagesToShow: faImages[8] });
      this.setState({ subexamsToShow: faSubExamNames[8] });
      this.state.socket.emit("send-WISCIV-QNumber", 8, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 8 &&
      this.state.questionsCounter == 21
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 9 });
      this.setState({ imagesToShow: faImages[9] });
      this.setState({ subexamsToShow: faSubExamNames[9] });
      this.state.socket.emit("send-WISCIV-QNumber", 9, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 9 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 10 });
      this.setState({ imagesToShow: faImages[10] });
      this.setState({ subexamsToShow: faSubExamNames[10] });
      this.state.socket.emit("send-WISCIV-QNumber", 10, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 10 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 11 });
      this.setState({ imagesToShow: faImages[11] });
      this.setState({ subexamsToShow: faSubExamNames[11] });
      this.state.socket.emit("send-WISCIV-QNumber", 11, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 11 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 12 });
      this.setState({ imagesToShow: faImages[12] });
      this.setState({ subexamsToShow: faSubExamNames[12] });
      this.state.socket.emit("send-WISCIV-QNumber", 12, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 12 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 13 });
      this.setState({ imagesToShow: faImages[13] });
      this.setState({ subexamsToShow: faSubExamNames[13] });
      this.state.socket.emit("send-WISCIV-QNumber", 13, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 13 &&
      this.state.questionsCounter == 34
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 14 });
      this.setState({ imagesToShow: faImages[14] });
      this.setState({ subexamsToShow: faSubExamNames[14] });
      this.state.socket.emit("send-WISCIV-QNumber", 14, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 14 &&
      this.state.questionsCounter == 1
    ) {
      this.setState({ questionsCounter: 0 });
      this.setState({ subexamsCounter: 15 });
      this.setState({ imagesToShow: faImages[15] });
      this.setState({ subexamsToShow: faSubExamNames[15] });
      this.state.socket.emit("send-WISCIV-QNumber", 15, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 15 &&
      this.state.questionsCounter == 0
    ) {
      console.log("We are the champions ...");
      this.sendAnsweredQuestions();
    } else {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
      this.state.socket.emit(
        "send-WISCIV-QNumber",
        this.state.subexamsCounter,
        this.state.questionsCounter + 1,
        this.state.roomId
      );
    }
  };

  previousQuestionNumberHandler = () => {
    if (
      this.state.subexamsCounter == 0 &&
      this.state.questionsCounter == 2 &&
      this.state.childAge >= 96 &&
      this.state.childAge < 204
    ) {
      // for age 8 to 17
      this.setState({ questionsCounter: 0 });
      this.state.socket.emit("send-WISCIV-QNumber", 0, 0, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 0 &&
      this.state.questionsCounter == 3 &&
      this.state.childAge >= 72 &&
      this.state.childAge < 96
    ) {
      // for age 6 to 8
      this.setState({ questionsCounter: 1 });
      this.state.socket.emit("send-WISCIV-QNumber", 0, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 1 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 14 });
      this.setState({ subexamsCounter: 0 });
      this.setState({ imagesToShow: faImages[0] });
      this.setState({ subexamsToShow: faSubExamNames[0] });
      this.state.socket.emit("send-WISCIV-QNumber", 0, 14, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 2 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 24 });
      this.setState({ subexamsCounter: 1 });
      this.setState({ imagesToShow: faImages[1] });
      this.setState({ subexamsToShow: faSubExamNames[1] });
      this.state.socket.emit("send-WISCIV-QNumber", 1, 24, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 3 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 34 });
      this.setState({ subexamsCounter: 2 });
      this.setState({ imagesToShow: faImages[2] });
      this.setState({ subexamsToShow: faSubExamNames[2] });
      this.state.socket.emit("send-WISCIV-QNumber", 2, 34, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 4 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 30 });
      this.setState({ subexamsCounter: 3 });
      this.setState({ imagesToShow: faImages[3] });
      this.setState({ subexamsToShow: faSubExamNames[3] });
      this.state.socket.emit("send-WISCIV-QNumber", 3, 30, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 5 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 4 });
      this.setState({ imagesToShow: faImages[4] });
      this.setState({ subexamsToShow: faSubExamNames[4] });
      this.state.socket.emit("send-WISCIV-QNumber", 4, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 6 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 36 });
      this.setState({ subexamsCounter: 5 });
      this.setState({ imagesToShow: faImages[5] });
      this.setState({ subexamsToShow: faSubExamNames[5] });
      this.state.socket.emit("send-WISCIV-QNumber", 5, 36, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 7 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 32 });
      this.setState({ subexamsCounter: 6 });
      this.setState({ imagesToShow: faImages[6] });
      this.setState({ subexamsToShow: faSubExamNames[6] });
      this.state.socket.emit("send-WISCIV-QNumber", 6, 32, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 8 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 38 });
      this.setState({ subexamsCounter: 7 });
      this.setState({ imagesToShow: faImages[7] });
      this.setState({ subexamsToShow: faSubExamNames[7] });
      this.state.socket.emit("send-WISCIV-QNumber", 7, 38, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 9 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 21 });
      this.setState({ subexamsCounter: 8 });
      this.setState({ imagesToShow: faImages[8] });
      this.setState({ subexamsToShow: faSubExamNames[8] });
      this.state.socket.emit("send-WISCIV-QNumber", 8, 21, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 10 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 9 });
      this.setState({ imagesToShow: faImages[9] });
      this.setState({ subexamsToShow: faSubExamNames[9] });
      this.state.socket.emit("send-WISCIV-QNumber", 9, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 11 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 10 });
      this.setState({ imagesToShow: faImages[10] });
      this.setState({ subexamsToShow: faSubExamNames[10] });
      this.state.socket.emit("send-WISCIV-QNumber", 10, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 12 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 11 });
      this.setState({ imagesToShow: faImages[11] });
      this.setState({ subexamsToShow: faSubExamNames[11] });
      this.state.socket.emit("send-WISCIV-QNumber", 11, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 13 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 12 });
      this.setState({ imagesToShow: faImages[12] });
      this.setState({ subexamsToShow: faSubExamNames[12] });
      this.state.socket.emit("send-WISCIV-QNumber", 12, 1, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 14 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 34 });
      this.setState({ subexamsCounter: 13 });
      this.setState({ imagesToShow: faImages[13] });
      this.setState({ subexamsToShow: faSubExamNames[13] });
      this.state.socket.emit("send-WISCIV-QNumber", 13, 34, this.state.roomId);
    } else if (
      this.state.subexamsCounter == 15 &&
      this.state.questionsCounter == 0
    ) {
      this.setState({ questionsCounter: 1 });
      this.setState({ subexamsCounter: 14 });
      this.setState({ imagesToShow: faImages[14] });
      this.setState({ subexamsToShow: faSubExamNames[14] });
      this.state.socket.emit("send-WISCIV-QNumber", 14, 1, this.state.roomId);
    } else if (this.state.questionsCounter > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter - 1 });
      this.state.socket.emit(
        "send-WISCIV-QNumber",
        this.state.subexamsCounter,
        this.state.questionsCounter - 1,
        this.state.roomId
      );
    }
  };

  wechslerExamHandler = (value) => {
    this.setState({ questionsCounter: 0 });
    this.setState({ subexamsCounter: value });
  };

  wechslerScoreHandler = (value) => {
    if (this.state.subexamsCounter != 15) {
      this.state.questions[this.state.subexamsCounter][
        this.state.questionsCounter
      ] = value;
    }
    console.log(this.state.questions);
    // console.log([Object.values(this.state.questions[0]),Object.values(this.state.questions[1])])

    this.nextQuestionNumberHandler();
  };

  wechslerSaveHandler = async () => {
    const response = await axios.post(
      "https://request.kidiar.com/evaluation/checkpoint",
      {
        testName: "WISC4",
        audienceId: this.state.userId,
        questions: [
          Object.keys(this.state.questions[0]),
          Object.keys(this.state.questions[1]),
          Object.keys(this.state.questions[2]),
          Object.keys(this.state.questions[3]),
          Object.keys(this.state.questions[4]),
          Object.keys(this.state.questions[5]),
          Object.keys(this.state.questions[6]),
          Object.keys(this.state.questions[7]),
          Object.keys(this.state.questions[8]),
          Object.keys(this.state.questions[9]),
          Object.keys(this.state.questions[10]),
          Object.keys(this.state.questions[11]),
          Object.keys(this.state.questions[12]),
          Object.keys(this.state.questions[13]),
          Object.keys(this.state.questions[14]),
        ],
        answers: [
          Object.values(this.state.questions[0]),
          Object.values(this.state.questions[1]),
          Object.values(this.state.questions[2]),
          Object.values(this.state.questions[3]),
          Object.values(this.state.questions[4]),
          Object.values(this.state.questions[5]),
          Object.values(this.state.questions[6]),
          Object.values(this.state.questions[7]),
          Object.values(this.state.questions[8]),
          Object.values(this.state.questions[9]),
          Object.values(this.state.questions[10]),
          Object.values(this.state.questions[11]),
          Object.values(this.state.questions[12]),
          Object.values(this.state.questions[13]),
          Object.values(this.state.questions[14]),
        ],
      },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 1) {
      console.log("Save is done!");
    }
  };

  sendAnsweredQuestions = async () => {
    const results = await axios.post(
      "https://request.kidiar.com/evaluation/evaluate",
      {
        audienceId: this.state.userId,
        age: this.state.childAge, // 0, 1, 2, 3
        sex: this.state.gender,
        hasAutism: this.state.autismBackground,
        diagAutism: this.state.autismDiagnosis,
        questions: [
          Object.keys(this.state.questions[0]),
          Object.keys(this.state.questions[1]),
          Object.keys(this.state.questions[2]),
          Object.keys(this.state.questions[3]),
          Object.keys(this.state.questions[4]),
          Object.keys(this.state.questions[5]),
          Object.keys(this.state.questions[6]),
          Object.keys(this.state.questions[7]),
          Object.keys(this.state.questions[8]),
          Object.keys(this.state.questions[9]),
          Object.keys(this.state.questions[10]),
          Object.keys(this.state.questions[11]),
          Object.keys(this.state.questions[12]),
          Object.keys(this.state.questions[13]),
          Object.keys(this.state.questions[14]),
        ],
        answers: [
          Object.values(this.state.questions[0]),
          Object.values(this.state.questions[1]),
          Object.values(this.state.questions[2]),
          Object.values(this.state.questions[3]),
          Object.values(this.state.questions[4]),
          Object.values(this.state.questions[5]),
          Object.values(this.state.questions[6]),
          Object.values(this.state.questions[7]),
          Object.values(this.state.questions[8]),
          Object.values(this.state.questions[9]),
          Object.values(this.state.questions[10]),
          Object.values(this.state.questions[11]),
          Object.values(this.state.questions[12]),
          Object.values(this.state.questions[13]),
          Object.values(this.state.questions[14]),
        ],
        test: "WISC4",
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    console.log("server answer is: ", results.data);
    this.setState({ wisc4Result: results.data.result });
  };

  render() {
    if (this.state.isLoaded == false) {
      return (
        <div className="result-page">
          {"سوالات در حال بارگزاری می‌باشند ..."}
        </div>
      );
    }

    if (this.state.finishedAnswering == true) {
      return (
        <div className="screening-test" style={{ backgroundImage: "none" }}>
          {this.state.testResultsText[0]}
        </div>
      );
    }

    return (
      <div className="screening-test">
        {this.state.accessType != "User" && (
          <button
            onClick={() => this.nextQuestionNumberHandler()}
            className="pushButton-next-question"
          >
            <img src={arrowImage}></img>
          </button>
        )}
        {this.state.subexamsCounter == 0 && (
          <WiscIVCubes
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[0]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 1 && (
          <WiscIVSimilarities
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[1]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 2 && (
          <WiscIVSequencing
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[2]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 3 && (
          <WiscIVConcepts
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[3]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 4 && (
          <WiscIVCoding
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[4]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 5 && (
          <WiscIVVocabulary
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[5]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 6 && (
          <WiscIVAlphaNum
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[6]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 7 && (
          <WiscIVMatrices
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[7]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 8 && (
          <WiscIVComprehension
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[8]}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 9 && (
          <WiscIVSymbols
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[9]}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 10 && (
          <WiscIVCompletion
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[10]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 11 && (
          <WiscIVCancellation
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[11]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 12 && (
          <WiscIVGeneral
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[12]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 13 && (
          <WiscIVArithmetic
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[13]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
            saveScore={() => this.wechslerSaveHandler()}
          />
        )}
        {this.state.subexamsCounter == 14 && (
          <WiscIVVerbal
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[14]}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}
        {this.state.subexamsCounter == 15 && (
          <WiscIVSubmit
            access={this.state.accessType}
            counts={this.state.questionsCounter}
            images={faImages[15]}
            audience={this.state.userId}
            result={this.state.wisc4Result}
            setSubExam={(subexam) => this.wechslerExamHandler(subexam)}
            setScore={(score) => this.wechslerScoreHandler(score)}
          />
        )}

        {this.state.accessType != "User" && (
          <button
            onClick={() => this.previousQuestionNumberHandler()}
            className="pushButton-previous-question"
          >
            <img src={arrowImage}></img>
          </button>
        )}
      </div>
    );
  }
}

export default Wisc4;
